
<span class="loader" 
[style.--scale-loader]=" width / 48"
[style.--loaderThickness]=" thickness + 'px'"
[style.--top]=" (width* 0.25)+ 'px'"
[style.--left]="  (width* 0.25)+ 'px'"
[style.--primaryColor]="primaryColor"
[style.--secondaryColor]="secondaryColor"></span>